import BulkInventoryUploadApi from "../../services/api/BulkInventoryUpload";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";

const handleError = (err) => {
  console.log("[handleError] Error in BulkInventoryUpload actions", err);
};

export const getUploadUrl = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await BulkInventoryUploadApi.getUploadUrl(payload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
